import React from 'react'
import KanBoIcon from 'components/KanBoIcon'
import classes from './ColorPicker.module.scss'
import { useSelector } from 'react-redux'

const ColorPicker = ({
  value,
  onChange,
}) => {
  const colors = useSelector<any, string[]>(state => state.kanbo.branding.colors)

  return (
    <div className={classes.colorContainer}>
      {colors.map((color, index) => {
        const isSelected = value === index

        const onColorClick = (event) => {
          if (!isSelected) {
            onChange(index)
          }
        }

        let colorClassName = classes.color + ' ' + classes.hover
        if (isSelected) colorClassName += ' ' + classes.selected

        return (
          <div
            key={index}
            style={{
              backgroundColor: color,
            }}
            className={colorClassName}
            onClick={onColorClick}
          >
            {isSelected &&
              <div className={classes.iconWrapper}>
                <KanBoIcon name='kanbo-16-tasks' />
              </div>
            }
          </div>
        )
      })}
    </div>
  )
}

export default ColorPicker